import React, { useState } from 'react';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiArrowUp, FiArrowDown, FiTrash2, FiMove } = FiIcons;
export const ITEM_TYPES = ['welcome', 'hymn', 'reading', 'tribute', 'prayer', 'eulogy', 'committal', 'blessing', 'custom'];

const ItemList = ({ items, selectedId, onSelect, onMove, onRemove, onAdd }) => {
  const [dragFrom, setDragFrom] = useState(null);
  const [newType, setNewType] = useState('reading');

  return (
    <div className="bg-white border border-brand-dark rounded-2xl p-4">
      <h3 className="font-serif text-lg font-bold text-accent-navy mb-3">Order of service</h3>
      <ul className="space-y-2">
        {items.map((item, index) => (
          <li
            key={item.id}
            draggable
            onDragStart={() => setDragFrom(index)}
            onDragOver={event => event.preventDefault()}
            onDrop={() => { if (dragFrom !== null) onMove(dragFrom, index); setDragFrom(null); }}
            onClick={() => onSelect(item.id)}
            className={`flex items-center gap-2 border rounded-xl px-3 py-2 cursor-pointer ${selectedId === item.id ? 'border-accent-gold bg-accent-gold/10' : 'border-brand-dark'}`}
          >
            <SafeIcon icon={FiMove} className="w-4 h-4 text-text-muted shrink-0" />
            <div className="flex-1 min-w-0">
              <p className="text-[10px] uppercase tracking-widest text-text-muted">{item.type}</p>
              <p className="text-sm font-semibold text-accent-navy truncate">{item.title || 'Untitled'}</p>
            </div>
            <div className="flex gap-1" onClick={event => event.stopPropagation()}>
              <button type="button" onClick={() => onMove(index, index - 1)} className="p-1 text-text-muted"><SafeIcon icon={FiArrowUp} className="w-4 h-4" /></button>
              <button type="button" onClick={() => onMove(index, index + 1)} className="p-1 text-text-muted"><SafeIcon icon={FiArrowDown} className="w-4 h-4" /></button>
              <button type="button" onClick={() => onRemove(item.id)} className="p-1 text-red-500"><SafeIcon icon={FiTrash2} className="w-4 h-4" /></button>
            </div>
          </li>
        ))}
        {items.length === 0 && <li className="text-xs text-text-muted">No items yet. Add a hymn from the library or add a section below.</li>}
      </ul>
      <div className="flex gap-2 mt-3">
        <select value={newType} onChange={event => setNewType(event.target.value)} className="flex-1 text-sm border border-brand-dark rounded-lg px-2 py-2">
          {ITEM_TYPES.filter(type => type !== 'hymn').map(type => <option key={type} value={type}>{type}</option>)}
        </select>
        <button type="button" onClick={() => onAdd(newType, null)} className="px-3 py-2 rounded-lg bg-accent-navy text-white text-sm font-bold">Add</button>
      </div>
    </div>
  );
};

export default ItemList;